import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Completes native Android Google OAuth without a full page reload.
 * MainActivity injects localStorage then dispatches `kayicom-native-session`.
 * A hard location.replace was leaving a black WebView while the SPA rebooted.
 */
export default function NativeSessionListener({ login }) {
  const navigate = useNavigate();

  useEffect(() => {
    const onNativeSession = (event) => {
      try {
        const detail = event?.detail || {};
        const userData = detail.user || detail;
        if (!userData || typeof userData !== 'object') return;
        window.__kayicomNativeSessionHandled = true;
        if (typeof login === 'function') {
          login(userData, { remember: true });
        } else {
          try {
            localStorage.setItem('user', JSON.stringify(userData));
          } catch {
            // ignore
          }
        }
        const role = userData.role;
        const dest = detail.dest
          || (role === 'admin' ? '/admin' : '/dashboard');
        navigate(dest, { replace: true });
        try {
          window.dispatchEvent(new Event('kayicom-app-ready'));
        } catch {
          // ignore
        }
      } catch (e) {
        console.error('Native session apply failed', e);
        window.__kayicomNativeSessionHandled = false;
      }
    };

    window.addEventListener('kayicom-native-session', onNativeSession);
    return () => window.removeEventListener('kayicom-native-session', onNativeSession);
  }, [login, navigate]);

  return null;
}
